import 'bootstrap';
import 'swiper/css/swiper.min.css';
import "@fancyapps/ui/dist/fancybox.css";

import './scripts';
import './styles/index.scss';
